import { notification } from 'antd';

import MessagesTypes from '../action-types/messages';
import {
  createBreederMessage,
  getMessages,
  getUsers,
  postInternalNote,
} from './messages.helpers';
import { formatInternalNote } from 'components/organisms/ListingViewMessageCenter/TabNotes/getNotesFromListing';
import { userSessionFullName } from 'utils/user/userSession';

const setTabLoading = () => {
  return {
    type: MessagesTypes.SET_TAB_LOADING,
  };
};

const fetchMessagesSuccessObject = (data) => {
  return {
    type: MessagesTypes.FETCH_MESSAGES_SUCCESS,
    data,
  };
};

const fetchMessagesErrorObject = (error) => {
  return {
    type: MessagesTypes.FETCH_MESSAGES_ERROR,
    error,
  };
};

const createMessageRequestObject = () => {
  return {
    type: MessagesTypes.CREATE_MESSAGE_REQUEST,
  };
};

const createMessageSuccessObject = (message) => {
  return {
    type: MessagesTypes.CREATE_MESSAGE_SUCCESS,
    message,
  };
};

const createMessageErrorObject = (error) => {
  return {
    type: MessagesTypes.CREATE_MESSAGE_ERROR,
    error,
  };
};

export const setTab = (tab) => {
  return {
    type: MessagesTypes.SET_TAB,
    tab,
  };
};

export const setMode = (mode) => {
  return {
    type: MessagesTypes.SET_MODE,
    mode,
  };
};

export const actionNotesTabIsLoading = (notesTabIsLoading) => {
  return {
    type: MessagesTypes.NOTES_TAB_IS_LOADING,
    notesTabIsLoading,
  };
};

export const actionAddNote = (note) => {
  return {
    type: MessagesTypes.ADD_NEW_INTERNAL_NOTE,
    note,
  };
};

export const actionToggleTabNotesMode = () => {
  return {
    type: MessagesTypes.TOGGLE_TAB_NOTES_MODE,
  };
};

export const setTabNotes = (notes) => {
  return {
    type: MessagesTypes.SET_TAB_NOTES,
    notes,
  };
};

export const updateNote = (newNote) => {
  return {
    type: MessagesTypes.UPDATE_NOTE,
    newNote,
  };
};

export function addInternalNote(note) {
  return async (dispatch) => {
    try {
      dispatch(actionNotesTabIsLoading(true));
      const response = await postInternalNote(note);
      const receivedNote = response?.notes?.[0];

      notification.success({ message: 'Note created' });

      const newInternalNote = formatInternalNote({ ...receivedNote });
      dispatch(actionAddNote(newInternalNote));
      dispatch(actionToggleTabNotesMode());
    } catch (error) {
      notification.error({ message: 'Try again in a few moments' });
    } finally {
      setTimeout(() => {
        dispatch(actionNotesTabIsLoading(false));
      }, 500);
    }
  };
}

export function fetchMessages(breederId, listingId) {
  return async (dispatch) => {
    try {
      dispatch(setTabLoading());

      const messages = await getMessages(breederId, listingId);
      const users = await getUsers(new Set(messages.map((o) => o.authorId)));

      dispatch(
        fetchMessagesSuccessObject({
          messages,
          users: users.map((o) => o.user),
        })
      );
    } catch (error) {
      if (typeof error === 'string') {
        dispatch(fetchMessagesErrorObject(error));
      } else {
        dispatch(fetchMessagesErrorObject(error.message));
      }
    }
  };
}

export const actionAddBreederMessage = (message) => {
  return {
    type: MessagesTypes.ADD_BREEDER_MESSAGE,
    message,
  };
};

export function createMessage(message) {
  return async (dispatch) => {
    try {
      dispatch(createMessageRequestObject());
      const data = await createBreederMessage(message);

      dispatch(createMessageSuccessObject(data));
      dispatch(setMode('list'));
      if (data?.success) {
        const temporaryTimestampId = new Date().getTime();
        const newMessage = {
          id: temporaryTimestampId,
          createdAt: new Date().toDateString(),
          author: userSessionFullName(),
          replacements: JSON.stringify({ PLM_CONTENT: message.message }),
        };
        dispatch(actionAddBreederMessage(newMessage));
      }
    } catch (error) {
      if (typeof error === 'string') {
        dispatch(createMessageErrorObject(error));
      } else {
        dispatch(createMessageErrorObject(error.errors));
      }
    }
  };
}
